import validateForm from '@ott/utility-form-validate';
import { isDifferentDirections } from '@ott/utility-form-validate-rules';

export const MOSCOW_META_ID = 22823;
export const MOSCOW_KURSKAY_META_ID = 27132;

const MOSCOW_STATIONS = [MOSCOW_META_ID, MOSCOW_KURSKAY_META_ID];

const sameStations = {
  [MOSCOW_META_ID]: MOSCOW_STATIONS,
  [MOSCOW_KURSKAY_META_ID]: MOSCOW_STATIONS,
};

/**
 *
 * @param compareFunc функция для сравнения. Примает объект с value, props, blackList
 * @param blackList список значений, по которым не проходит валидация
 * @returns {Function} compareFunc({ value, props, blackList })
 */
function notInBlackList(compareFunc, blackList) {
  return function (value, props) {
    return compareFunc({
      value,
      props,
      blackList,
    });
  };
}

/**
 *
 * @param props
 * @param blackList
 * @returns {boolean}
 */
function notIdenticalStations({ props, blackList = {} }) {
  const { from, to } = props;
  if (!from || !to) {
    return true;
  }

  const fromCodeBlackList = blackList[from.id];

  if (!fromCodeBlackList) {
    return true;
  }

  return !fromCodeBlackList.includes(to.id);
}

const isDifferentDirectionsWithoutUndefined = (value, { from, to }) =>
  !from ||
  typeof from.id === 'undefined' ||
  !to ||
  typeof to.id === 'undefined' ||
  isDifferentDirections(value, { fromCode: from.id, toCode: to.id });

/**
 *
 * @param identicalIds
 * @returns {{msg: string, validate: Function}}
 */
const badRequest = (identicalIds = false) => ({
  msg: 'Неверный поисковый запрос',
  validate: identicalIds
    ? notInBlackList(notIdenticalStations, sameStations)
    : isDifferentDirectionsWithoutUndefined,
});

const isRequiredDate = (value) => Boolean(value && value.startDate);

const isRequiredTravellers = (value, values) => !(values.adults === 0 && values.children === 0);

const validationRules = {
  fromText: [
    {
      msg: 'Поле «Откуда» обязательно для заполнения',
      validate: (value) => {
        return Boolean(value);
      },
    },
    {
      msg: 'Станция не найдена',
      validate: (value, values) => {
        const { from, fromText } = values;

        return Boolean(from && from.id && from.name && from.name === fromText);
      },
    },
    badRequest(),
    badRequest(true),
  ],
  toText: [
    {
      msg: 'Поле «Куда» обязательно для заполнения',
      validate: (value) => {
        return Boolean(value);
      },
    },
    {
      msg: 'Станция не найдена',
      validate: (value, values) => {
        const { to, toText } = values;

        return Boolean(to && to.id && to.name && to.name === toText);
      },
    },
    badRequest(),
    badRequest(true),
  ],
  dates: [
    {
      msg: 'Не выбрана дата начала путешествия',
      validate: isRequiredDate,
    },
  ],
  // name from Travellers.js
  'travellers-trigger': [
    {
      msg: 'Необходимо указать количество пассажиров',
      validate: isRequiredTravellers,
    },
  ],
  // duplicate for the trigger's error hightlight
  totalChildren: [
    {
      msg: 'Необходимо указать количество пассажиров',
      validate: isRequiredTravellers,
    },
  ],
};

export default validateForm(validationRules);
